// apps/api/src/qxcircle/qxcircle-service-helpers.ts
// Description: Shared QXCircle service helpers — filter · handle · mention ntf.
// Owner: Masa Bayu
// Date: 2026-08-24

import { BadRequestException } from "./_nestjs-common";
import type { QxCircleNotification } from "./qxcircle.types";
import {
  createMentionNotification,
  extractQxCircleMentions,
} from "./qxcircle-mention";

export function parseQxCircleFeedFilter(filterRaw?: string): "all" | "following" {
  if (filterRaw?.trim().toLowerCase() === "following") {
    return "following";
  }
  return "all";
}

export function normalizeQxCircleAuthorHandle(handleRaw: string): string {
  const trimmed = handleRaw.trim();
  if (!trimmed) {
    throw new BadRequestException("Author handle required");
  }
  return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
}

export function buildMentionNotificationsForPost(
  seqStart: number,
  fromName: string,
  fromHandle: string,
  body: string,
  postId: string,
): { notifications: QxCircleNotification[]; nextSeq: number } {
  const self = fromHandle.replace(/^@/, "").toLowerCase();
  const notifications: QxCircleNotification[] = [];
  let seq = seqStart;
  for (const handle of extractQxCircleMentions(body)) {
    if (handle === self) continue;
    seq += 1;
    notifications.push(createMentionNotification(seq, fromName, handle, postId));
  }
  return { notifications, nextSeq: seq };
}
